"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.checkInit = exports.initFlagName = void 0;
exports.initFlagName = 'isAuthButtonInitialized';
function checkInit() {
    var initFlag = window.sessionStorage.getItem(exports.initFlagName);
    if (!initFlag) {
        return false;
    }
    try {
        var parsedInitFlag = JSON.parse(initFlag);
        return parsedInitFlag === true;
    }
    catch (error) {
        return false;
    }
}
exports.checkInit = checkInit;
//# sourceMappingURL=status.js.map